import { useState } from "react";

const API = window.location.hostname === "localhost"
  ? "http://localhost:8787"
  : "https://ams-onboarding-api.biglexlost.workers.dev";

const ACCEPT = ".pdf,.csv,.xls,.xlsx,.jpg,.jpeg,.png,.heic,.heif";
const MAX_BYTES = 15 * 1024 * 1024;

export function CallLogUpload({ clientId, token, draft, setDraft, admin }) {
  const fileRecord = draft.business?.callLogFile;
  const guaranteeSelected = draft.business?.guaranteeTier && draft.business.guaranteeTier !== "No guarantee";
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  const updateRecord = (file) => setDraft((current) => ({
    ...current,
    business: { ...current.business, callLogFile: file },
  }));

  async function upload(event) {
    const file = event.target.files?.[0];
    if (!file) return;
    setMessage("");
    if (file.size > MAX_BYTES) {
      setMessage("Choose a file that is 15 MB or smaller.");
      event.target.value = "";
      return;
    }
    setBusy(true);
    try {
      const response = await fetch(`${API}/api/client/${clientId}/call-log`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": file.type || "application/octet-stream",
          "X-File-Name": encodeURIComponent(file.name),
          ...(fileRecord?.objectKey ? { "X-Replace-Key": fileRecord.objectKey } : {}),
        },
        body: file,
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Upload failed");
      updateRecord(data.file);
      setMessage("Uploaded for AMS eligibility review.");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setBusy(false);
      event.target.value = "";
    }
  }

  async function download() {
    const response = await fetch(`${API}/api/client/${clientId}/call-log?key=${encodeURIComponent(fileRecord.objectKey)}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) return setMessage("Unable to download this file.");
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileRecord.name || "call-log";
    link.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="call-log-upload">
      <div>
        <b>Previous month’s complete call log {guaranteeSelected && <em>Required</em>}</b>
        <span>Upload the complete report used to verify guarantee eligibility. PDF, CSV, XLSX, or phone photos, up to 15 MB.</span>
      </div>
      {fileRecord ? (
        <div className="upload-result">
          <span><b>{fileRecord.name}</b><small>{fileRecord.reviewStatus === "submitted" ? "Submitted for review" : fileRecord.reviewStatus}</small></span>
          {admin && <button type="button" className="secondary" onClick={download}>Download</button>}
          <label className="secondary upload-button">Replace file<input type="file" accept={ACCEPT} onChange={upload} disabled={busy} /></label>
        </div>
      ) : (
        <label className="upload-button">{busy ? "Uploading…" : "Choose call-log file"}<input type="file" accept={ACCEPT} onChange={upload} disabled={busy || !guaranteeSelected} /></label>
      )}
      {!guaranteeSelected && <small>Select a guarantee tier to enable this required upload.</small>}
      {message && <small className={message.startsWith("Uploaded") ? "success" : "error"}>{message}</small>}
    </div>
  );
}
